/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForJiraServiceDesk extends models.GovernanceConfigurationBaseForItsm {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForJiraServiceDesk.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForJiraServiceDesk>): GovernanceConfigurationBaseForJiraServiceDesk {
        let obj = Object.assign(new GovernanceConfigurationBaseForJiraServiceDesk(), model);
        GovernanceConfigurationBaseForJiraServiceDesk.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForJiraServiceDesk>): GovernanceConfigurationBaseForJiraServiceDesk {
        if (!model) return null;
        return GovernanceConfigurationBaseForJiraServiceDesk.newInstance(<GovernanceConfigurationBaseForJiraServiceDesk> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForJiraServiceDesk) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForJiraServiceDesk.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForJiraServiceDesk): boolean {
        if (models.GovernanceConfigurationBaseForItsm.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForJiraServiceDesk.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
